const composeSelectors = {
    'actionId': 'actionID',
    'appContainerId': 'mailbox-container',
    'composeFormId': 'composeForm',
    'headersContainer': 'eml-compose__headers',
    'message': 'eml-compose__message',
    'requestReceiptId': 'request-return-receipt',
    'saveSentId': 'id_save_sent',
    'toolbarContainer': 'eml-compose__toolbar-container',
};

export default composeSelectors;
